<template>
    <form @submit="submit" class="item-editor-form">
        <fg-input v-model="item.tunnus" :label="$t('line_view.id')" :disabled="action == 'edit'"></fg-input>
        <fg-input v-model="item.tunnusteksti" :label="$t('line_view.line_number')" :disabled="inputDisabled"></fg-input>
        <fg-input v-model="item.nimi" :label="$t('line_view.name')" :disabled="inputDisabled"></fg-input>
        <label for="organisaatio">{{ $t('line_view.organisation') }}:</label>
        <organisationSelect v-model="item.organisaatio" id="organisaatio" :disabled="inputDisabled"/>
       
        <div v-if="action == 'edit'" class="line-features">
            <div v-for="orgLineFeature in organisationLineFeatures" :key="orgLineFeature.id">
                <div v-if="orgLineFeature.type === 'BOOLEAN'" class="line-feature">
                    <label>{{ $t(orgLineFeature.descriptionId) }}</label>
                    <b-form-checkbox value="true" unchecked-value="false" v-model="item.features[orgLineFeature.name]" />
                </div>
                <div v-else-if="orgLineFeature.type === 'SELECT'">
                    <label>{{ $t(orgLineFeature.descriptionId) }}</label>
                    
                    <vSelect v-model="formattedFeatures[orgLineFeature.name]" :options="orgLineFeature.validValues" label="descriptionId" :disabled="inputDisabled"   >
                        <!--
                        <template v-slot:selected-option="selected">
                                {{$t(selected.descriptionId)}} 
                        </template>
                        -->
                       <template v-slot:selected-option>
                                {{$t(formattedFeatures[orgLineFeature.name].descriptionId)}} 
                        </template>
                                          
                        <template v-slot:item="item">
                                {{$t(item.descriptionId)}} 
                        </template>
                        <template v-slot:option="option">
                                {{$t(option.descriptionId)}}
                        </template> 
                    </vSelect>

                </div>
                <div v-else>
                    <fg-input v-bind:label="$t(orgLineFeature.descriptionId)" v-model="item.features[orgLineFeature.name]" />
                </div>
            </div>
        </div>
        
        <FormButtons
            @submit="submit"
            :submit="$UIPrivilegeUpdate('timetables', 'lines')"  
            :reset="false" 
            :remove="action == 'edit' && $UIPrivilegeDelete('timetables', 'lines')" 
            @remove="remove"
            :itemid="this.item.tunnus"
            :modalid="'lineEditModal'"
            :disableSubmit="loading"
            :disableRemove="loading "/>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    
    </form>
    
</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import organisationSelect from '@/components/Timetable/OrganisationSelect'
import timetable from '@/store/timetable/timetable'
import vSelect from 'vue-select'

export default {
    components: {
        FormButtons, organisationSelect, vSelect
    },
    props: {
        item: {        
            default: function () {
                return {
                    "tunnus": null,
                    "tunnusteksti": null,
                    "nimi": null,
                    "organisaatio": null,
                    "features": {
                    }
                }
            }        
         },
        action: { default: "new" }
    },
    data: function() {
        return  {
            ok: false,
            error: false,
            loading: false,
            infoType: "save",
            formattedFeatures: {}
        }
    },    
    mounted: function() {
        if(this.$store.state.timetable){
          this.$store.dispatch('timetable/getOrganisationLineFeatures', this.item.organisaatio);
        }
        this.formattedFeatures = {};
        
        if(!this.formattedFeatures) this.formattedFeatures = {};
        for( let [featureName, feature] of Object.entries(this.item.features)){
            this.formattedFeatures[featureName] = {};
            this.formattedFeatures[featureName].value = feature;
        }
    },
    computed: {
        organisationLineFeatures() {
            return this.$store.state.timetable.organisationLineFeatures.list;
        },
        inputDisabled(){
            return this.loading || !this.$UIPrivilegeU('timetables','lines');
        }
    },
    watch: {
        item(){
            this.ok = this.error = this.loading = false;  
            this.formattedFeatures = {};

            for( let [featureName, feature] of Object.entries(this.item.features)){    
                this.formattedFeatures[featureName] = {};
                this.formattedFeatures[featureName].value = feature;
            }

            if(this.$store.state.timetable){
                this.$store.dispatch('timetable/getOrganisationLineFeatures', this.item.organisaatio);
            }
            this.matchDescription();
        },
        'item.organisaatio'(){
            if(this.$store.state.timetable){
                this.$store.dispatch('timetable/getOrganisationLineFeatures', this.item.organisaatio);
            }
        },
        organisationLineFeatures(){
            this.matchDescription();
        }
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }    
    },
    methods: {
        submit(event) {
            if( event ) 
                event.preventDefault();

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            for( let [featureName, feature] of Object.entries(this.formattedFeatures)){
                this.item.features[featureName] = feature.value;
            }

            setTimeout(() => { 
                this.$store.dispatch('timetable/updateLine' , this.item).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);

        },
        matchDescription(){
            for( let [featureName, feature] of Object.entries(this.formattedFeatures)){
                let featObj = this.organisationLineFeatures.filter( feat => {
                    return feat.name == featureName
                    });
                if(featObj[0]){
                    let selected = featObj[0].validValues.filter( val => {
                        return val.value == feature.value
                    })[0];
                    feature.descriptionId = selected.descriptionId;
                }
            }
        },
        reset(event){
            event.preventDefault();
            this.item = {};              
        },
        remove() {
            this.infoType = "delete";
            this.loading = true;

            setTimeout(() => { 
                this.$store.dispatch('timetable/deleteLine' , this.item.tunnus).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                }) 
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    //this.$emit('newItem');
                })
            }, 1000);
        }

    }        
}
</script>

<style lang="scss" scoped>

.line-features {
    padding-top: 1em;
    padding-bottom: 0.5em;
}
.line-feature {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5em;
}

</style>

